export default "__VITE_ASSET__JkZuYR4s__"